/**
 * A first guess at the plural of the dial's word for an action point (KEY-560). The server needs both forms, so Start suggests
 * the plural as the author types; it's only ever a suggestion they can see and change.
 */
export function suggestPlural(singular: string): string {
  const word = singular.trim();
  if (!word) return "";
  if (/[^aeiou]y$/i.test(word)) return `${word.slice(0, -1)}ies`;
  if (/(s|x|z|ch|sh)$/i.test(word)) return `${word}es`;
  return `${word}s`;
}
